import { Injectable } from '@angular/core';
import { BookingsSearch } from '@fry/booking/lib/bookings';
import { Filter } from '@fry/lib/list';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';

@Injectable()
export class OptionBookingsSearch extends BookingsSearch {
  public filters(): Observable<Filter[]> {
    return this.bookings.aggregates().pipe(
      catchError(err => {
        console.log(err);
        return of([]);
      }),
      switchMap(aggs => {
        return forkJoin([
          this.fulltext(),
          // this.types(),
          // this.bookingItemName(aggs),
          // this.bookingOptionName(aggs),
          // this.items(),
          this.bookingConfirmation(),
          this.stateName(aggs),
        ]);
      }),
      map((filters): Filter[] => {
        const isFilter = (obj: any): obj is Filter => {
          return obj !== undefined;
        };

        return filters.filter(isFilter);
      })
    );
  }
}